export const CLOSE_ICON = 'https://acko-cms.ackoassets.com/Close_b4960d98e5.svg'
export const CHEVRON_LEFT_LIGHT = 'https://acko-cms.ackoassets.com/Chevron_left_light_9cfbc3dacb.svg'
export const SEARCH = 'https://acko-cms.ackoassets.com/search_a6_ac5f413263.svg'
export const CIRCULAR_CLOSE = 'https://acko-cms.ackoassets.com/close_circular_light_789a6a4871.svg'
export const CHEVRON_RIGHT_BLUE = 'https://acko-cms.ackoassets.com/Chevron_right_blue_c9e3ee0105.svg'
export const CHEVRON_RIGHT_DARK = 'https://acko-cms.ackoassets.com/chevron_683239dadb.png'
export const USER_ICON = ''
export const BACK_ICON = ''
export const MENU_ICON = ''
export const MAP_PIN = 'https://acko-cms.ackoassets.com/location_b5b64052de.svg'
export const ITEM_ICON = '' // temporary, the component requires dynamic icons
export const HamburgerMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true">
    <path d="M4 12h16" />
    <path d="M4 18h16" />
    <path d="M4 6h16" />
  </svg>
)

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M5.00049 5L19.0005 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0005 5L5.00049 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
